// jQuery_T4NT(document).ready(function($) {

//      /**
//      *  Variant selection changed
//      *  data-variant-toggle="{{ variant.id }}"
//      */
// 	   $( document ).on( "variant:changed", function( evt ) {
// 	     // console.log( evt.currentVariant );
// 	     // $('[data-variant-toggle]').hide(0);
// 	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
// 	   });
// });
$(document).ready(()=>{
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    // path=/ ensures the cookie is available across your entire site
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

  //load more button for featured collection slider
  document.querySelectorAll('.load-more-btn').forEach(button => {
  const flickitySelector = button.dataset.target;
  const flickitySlider = document.querySelector(flickitySelector);
  const flkty = Flickityt4s.data(flickitySlider);

  button.addEventListener('click', async () => {
    if (button.dataset.loading === 'true') return;

    button.dataset.loading = 'true';
    button.disabled = true;
    const nextPage = parseInt(button.dataset.page, 10) + 2;
    const collectionHandle = button.dataset.collection;
    const btnText = button.querySelector('.t4s-btn-atc_text');
    const spinner = button.querySelector('.t4s-loading__spinner');
    const originalText = btnText?.innerText || 'Load more';
    if (btnText) btnText.innerText = 'Loading...';
    if (spinner) spinner.classList.remove('t4s-dn');

    try {
      const res = await fetch(`/collections/${collectionHandle}?page=${nextPage}&view=loadmore`);
      if (!res.ok) throw new Error('Failed to load');
      
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const items = doc.querySelectorAll('.t4s-product'); 

      if (items.length === 0) {
        button.style.display = 'none'; // Hide if nothing returned
      } else {
        items.forEach(item => {
          const clone = item.cloneNode(true);
          flickitySlider.appendChild(clone);
          flkty.append(clone);
        });
        button.dataset.page = nextPage.toString();
      }
    } catch (err) {
      console.error('Load more failed:', err);
    } finally {
      button.dataset.loading = 'false';
      button.disabled = false;

      const btnText = button.querySelector('.t4s-btn-atc_text');
      const spinner = button.querySelector('.t4s-loading__spinner');

      if (btnText) btnText.innerText = 'Load more'; // Replace with original text if needed
      if (spinner) spinner.classList.add('t4s-dn');
      flkty.select(0);
    }
  });
});


});


